import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAlbumNavigation } from "@/hooks/useAlbumNavigation";
import { Images, ImageUp } from "lucide-react";
import { useEffect } from "react";
import { useTranslation } from "@/hooks/useTranslation";

const AlbumFloatingNav = () => {
  const { getAlbumPath } = useAlbumNavigation();
  const location = useLocation();
  const { t } = useTranslation();

  // Inject CSS once to hide nav when body has the uploading class
  useEffect(() => {
    const STYLE_ID = 'floating-nav-hide-style';
    let styleEl = document.getElementById(STYLE_ID) as HTMLStyleElement | null;
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = STYLE_ID;
      styleEl.textContent = `
        body.hide-floating-nav .floating-nav { display: none !important; }
        body.usuario-panel-open .floating-nav { z-index: 40 !important; }
      `;
      document.head.appendChild(styleEl);
    }
  }, []);

  // Only show on /album, /subir, and /usuario pages
  const currentPath = location.pathname;
  const shouldShow = currentPath.includes('/album') || currentPath.includes('/subir') || currentPath.includes('/usuario');

  if (!shouldShow) {
    return null;
  }

  const isActive = (path: string) => currentPath.endsWith(path);

  const navItems = [
    {
      path: "/album",
      icon: Images,
      label: t("albumNavLabel"),
      iconFirst: true,
    },
    {
      path: "/subir",
      icon: ImageUp,
      label: t("upload"),
      iconFirst: true,
    },
  ];

  return (
    <div className="floating-nav fixed bottom-3 left-1/2 transform -translate-x-1/2 z-[9998]">
      <div className="bg-background/95 backdrop-blur-sm border border-border rounded-full shadow-lg px-2 py-2">
        <div className="flex items-center gap-1">
          {navItems.map((item) => {
            const active = isActive(item.path);
            const Icon = item.icon;

            return (
              <Link key={item.path} to={getAlbumPath(item.path)} className={`${active ? 'pointer-events-none' : ''}`}>
                <Button
                  variant="ghost"
                  size="md"
                  icon="md"
                  className={`h-12 rounded-full px-3 transition-all duration-200 ${active
                    ? 'bg-primary text-primary-foreground shadow-md'
                    : 'hover:bg-muted'
                    }`}
                >
                  <span className="flex items-center gap-1.5">
                    {!item.iconFirst && (
                      <span className="text-[11px] uppercase leading-none">{item.label}</span>
                    )}
                    <Icon
                      size={20}
                      strokeWidth={active ? 2 : 1.5}
                    />
                    {item.iconFirst && (
                      <span className="text-[11px] uppercase leading-none">{item.label}</span>
                    )}
                  </span>
                </Button>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AlbumFloatingNav;
